import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { BrandDot } from "@/components/util/BrandDot";
import { Reveal } from "@/components/util/Reveal";

export const FinalCTA = () => {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  const heading = s.cta_heading || "Big Project or Small, Let’s Get It Right.";
  const headingAccent = s.cta_heading_accent || "";
  const accentInline = !!s.cta_accent_inline;
  const subtext = s.cta_subtext || "A new brand, a website, a campaign, or a menu that needs to look professional — tell us what you’re working on, or order online in a few clicks.";
  const btnLabel = s.cta_button_label || "Start Your Project";
  const btnLink = s.cta_button_link || "/contact";
  const whatsapp = s.cta_whatsapp_url || "";
  const whatsappLabel = s.final_cta_whatsapp_label || "Chat on WhatsApp";
  const showDot = !!s.cta_show_dot;
  const eyebrow = s.cta_eyebrow || "";

  return (
    <section data-testid="final-cta" className="bg-gradient-to-r from-[#FF6600] via-[#FF7A1F] to-[#FF6600] py-16">
      <Reveal className="max-w-[1400px] min-[1440px]:max-w-[1720px] mx-auto px-4 sm:px-6 lg:px-10 min-[1440px]:px-[clamp(2.5rem,4vw,4rem)] grid md:grid-cols-[1.4fr_1fr] gap-8 items-center">
        <div className="text-black">
          {eyebrow && (
            <div data-testid="cta-eyebrow" className="text-black/70 text-[10.5px] font-bold tracking-[0.2em] uppercase mb-3">
              {eyebrow}
            </div>
          )}
          <h2 data-testid="cta-heading" className="font-display font-black text-[clamp(42px,12.5vw,52px)] leading-[0.95] tracking-[-0.02em] sm:text-4xl sm:leading-tight sm:tracking-tight md:text-5xl">
            {heading}
            {headingAccent && (
              accentInline
                ? <span className="text-[#0F0F0F]">{headingAccent}</span>
                : <> <span className="text-[#0F0F0F]">{headingAccent}</span></>
            )}
          </h2>
          {showDot && <BrandDot variant="dark" testId="cta-dot" className="!justify-start !my-3" />}
          <p data-testid="cta-subtext" className="mt-2 text-black/80 text-sm sm:text-base">
            {subtext}
          </p>
        </div>
        <div className="flex flex-wrap gap-3 md:justify-end">
          <Link
            to={btnLink}
            data-testid="cta-start-project"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#0F0F0F] text-white font-semibold px-7 py-3.5 transition-all hover:gap-3"
          >
            {btnLabel} <ArrowRight className="w-4 h-4" />
          </Link>
          {whatsapp && (
            <a
              href={whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-whatsapp"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-[#0F0F0F] text-[#0F0F0F] font-semibold px-7 py-3.5 transition-all hover:bg-[#0F0F0F] hover:text-white"
            >
              {whatsappLabel} <MessageCircle className="w-4 h-4" />
            </a>
          )}
        </div>
      </Reveal>
    </section>
  );
};